// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropDown_dropdown__3KU_y","title":"DropDown_title__1rKDY","wrap":"DropDown_wrap__39hRP","items":"DropDown_items__21ULS"};